
import { defineComponent, onMounted, PropType } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { campaign } from '@/json/json_loader';
import { ContentPurchaseCountDeclareModel } from '@/models/content_purchase_count_declare_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentPurchaseCountConfirm',
  components: {
    BaseStyle,
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentPurchaseCountDeclareModel>,
      default: undefined,
    },
  },
  setup() {
    const { purchaseItems } = useInsertDataStore();
    onMounted(() => {
      purchaseItems.value ??= campaign.targetItems;
    });

    return {
      purchaseItems,
    };
  },
});
